import { Box, Button, Modal } from "@mui/material";
import React from "react";
import { modalStyle } from "../../../../../../../../components/modalStyle";
import ReconcileForm from "./ReconcileForm";
import { secondAxios } from "../../../../../../../../api/axios";
import { useBOMDashboardContext } from "../../BOMDashboard.context";

export default function ReconcileBtn({ row }) {
  const { project } = useBOMDashboardContext();
  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState({
    description: row?.mrqMaterials[0]?.description,
    mrqId: row?.mrqMaterials[0]?.mrq?.id,
    quantity: "",
    poNumber: "",
    poDate: "",
    projectId: project.id,
    mrqMaterialsIds: [row?.mrqMaterials[0]?.id],
    vendor: {},
  });

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const onChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const onSubmit = async () => {
    console.log({ ...data, selectedBidVendors: [data.vendor?.name] });
    // console.log("mrqId", row?.mrqMaterials?.[0]?.mrq.id);
    const res = await secondAxios.post("po", {
      ...data,
      selectedBidVendors: [data.vendor?.name],
    });
    console.log({ res });
    if (res?.data?.id) {
      window.location.reload();
    }
  };

  return (
    <>
      <Button
        variant="contained"
        sx={{ float: "right", mb: 0.8 }}
        onClick={handleOpen}
        disabled={!row.mrqMaterials[0]?.description}
      >
        Reconcile
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <ReconcileForm
            row={row}
            data={data}
            handleClose={handleClose}
            onChange={onChange}
            onSubmit={onSubmit}
          />
        </Box>
      </Modal>
    </>
  );
}
